import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function SellSide() {
	return (
		<>
			<div className="beratung_cont" id="sell_side">
				<HelmetProvider>
					<Helmet>
						<title> Unternehmensverkäufen und Portfoliooptimierung</title>
						<meta
							name="description"
							content="Unternehmensverkäufen und Portfoliooptimierung"
						/>
						<meta
							name="keywords"
							content="Unternehmensverkäufen,Digitalisierungsberatung, Prozessberatung, Digitalisierungsberatung, Prozessberatung, Portfoliooptimierung , Feingeist, Berlin"
						/>
					</Helmet>
				</HelmetProvider>
				<h1>
					Beratung bei Unternehmensverkäufen und Portfoliooptimierung mit der
					Feingeist Beratung — Sell Side
				</h1>
				<h1>Ihr Ziel ist unser Maßstab</h1>
				<p>
					Die Feingeist Beratung begleitet Sie bei dem komplexen Vorhaben eines
					Unternehmensverkaufs bzw. einer Portfoliooptimierung.
				</p>
				<h1>Ihre Vorteile:</h1>
				<ul className="typeset-u-list">
					<li>Umfassende Begleitung mit Fokus auf Ihr Ziel</li>
					<li>Ausschlaggebende strategische Ansätze, wenn es darauf ankommt</li>
					<li>
						Bewährte Verhandlungserfahrung in den entscheidenden Situationen
					</li>
					<li>Umfassendes Netzwerk zu potentiellen Käufern.</li>
				</ul>
				<p>
					Ein von Beginn an auf Ihre Ziele abgestimmter und strukturierter
					Prozess ist die entscheidende Grundlage für eine gelingende
					Transaktion.
				</p>
				<h2>
					Wir begleiten Sie partnerschaftlich bei den wesentlichen Schritten:
				</h2>
				<ul className="typeset-u-list">
					<li>Analyse der Ausgangssituation</li>
					<li>Ausarbeitung einer umfassenden Strategie</li>
					<li>Bewertung des Unternehmens</li>
					<li>
						Prüfung der Möglichkeiten und Festlegung der nächsten Schritte
					</li>
					<li>
						Erstellung der wesentlichen Verkaufsunterlagen und der
						organisatorischen Planung
					</li>
					<li>Ansprache der potentiellen Käufer</li>
					<li>Begleitung bei den Kaufpreisverhandlungen</li>
				</ul>
				<p>
					In einem Verkaufsprozess ist auch das Netzwerk für den Erfolg
					richtungsweisend, da bestenfalls mehrere Bieter (bspw. in einem
					Bieterverfahren) die Wahrscheinlichkeit für eine gelungenen
					Transaktion erhöhen. Ferner ist die Verhandlungserfahrung des Beraters
					wesentlich, damit Ihre Interessen optimal in den Verkaufsverhandlungen
					vertreten werden.
				</p>
				<p>
					Wir beraten bei Unternehmensverkäufen in folgenden Konstellationen:
				</p>
				<ul className="typeset-u-list">
					<li>Externe Käufer</li>
					<li>Interne Käufer</li>
					<li>Management-Buy-Outs (MBO)</li>
					<li>Management-Buy-Ins (MBI)</li>
					<li>Fusionen</li>
				</ul>
				<p>
					Optimieren Sie vor dem Verkauf Ihr Unternehmen durch vorbereitende
					Maßnahmen. Dazu gehören unter anderem die bestmögliche strategische
					und organisatorische Ausrichtung sowie die optimale Darstellung Ihres
					Unternehmens.
				</p>
				<p>
					Unsere Experten unterstützen das Management und die Gesellschafter das
					Unternehmen optimal auf einen Verkauf vorzubereiten.
				</p>
				<p>Sprechen Sie uns an.</p>
			</div>
		</>
	);
}
